// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_bootstrap_dist_js_bootstrap_js-node_modules_lodash_lodash_js"], () => (__webpack_require__("./src/js/mighty.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
